import React from 'react';
import { Link } from 'react-router-dom';
import buildInfo from '../buildInfo';
import './About.css';

export default function About() {
  return (
    <div className="about-root">
      <nav className="about-nav">
        <Link to="/" className="about-back">← SafeHer</Link>
      </nav>

      <main className="about-main">
        <p className="about-label">Built by Someone Who Lived It</p>

        <img
          src="/nikki.png"
          alt="Nikethana K, founder of SafeHer"
          className="about-photo"
        />

        <h1 className="about-name">Nikethana</h1>
        <p className="about-role">Founder &amp; Builder</p>

        <p className="about-bio">
          SafeHer grew out of years of on-the-ground advocacy. Nikethana has conducted
          100+ street interviews across San Francisco, run election awareness campaigns,
          and worked at the intersection of policy and peer empowerment.
        </p>

        <div className="about-orgs">
          <a
            href="https://www.paritylab.org/"
            target="_blank"
            rel="noopener noreferrer"
            className="about-org-link"
          >
            Parity Lab, School Champion, Project Greenlight Youth Council
          </a>
          <a
            href="https://www.generationup.net/"
            target="_blank"
            rel="noopener noreferrer"
            className="about-org-link"
          >
            GenUp — Policy work improving community safety
          </a>
        </div>

        <p className="about-closing">
          SafeHer is the tool she wished existed.
        </p>

        {/* Build Info */}
        <div style={{
          marginTop: '48px',
          padding: '16px 20px',
          borderTop: '1px solid rgba(255,255,255,0.1)',
          textAlign: 'center',
        }}>
          <p style={{ fontSize: '11px', color: 'rgba(255,255,255,0.35)', margin: 0, letterSpacing: '0.5px', textTransform: 'uppercase' }}>
            Build Info
          </p>
          <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.55)', margin: '6px 0 2px', fontWeight: 600 }}>
            v{buildInfo.version}
          </p>
          <p style={{ fontSize: '12px', color: 'rgba(255,255,255,0.35)', margin: 0 }}>
            {buildInfo.buildTimestamp}
          </p>
        </div>
      </main>
    </div>
  );
}
